<template>
  <main class="sa-signup-box sa-signup-mob" v-if="!showUploadView">
    <div class="sa-signup-box-cont">
      <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg5">
          <div class="sa-tabs">
            <a
              v-on:click="tabSelection = 'login'"
              v-bind:class="[tabSelection === 'login' ? 'active' : '']"
              >Log In</a
            >
            <a
              v-on:click="tabSelection = 'signup'"
              v-bind:class="[tabSelection === 'signup' ? 'active' : '']"
              >Sign Up</a
            >
          </div>
          <div :tabSelection="tabSelection">
            <sign-in v-if="tabSelection === 'login'" @show-signup="showSignup"></sign-in>
            <ValidationObserver
              v-slot="{ handleSubmit }"
              tag="form"
              v-if="tabSelection === 'signup'"
            >
              <h1 class="sa-h-sm-up">Register</h1>
              <div class="sa-row">
                <div class="sa-col-sm6 sa-col-md6 sa-col-lg6">
                  <ValidationProvider
                    tag="div"
                    class="sa-form-group"
                    name="first name"
                    rules="required|alpha_spaces|englishtxt"
                    v-slot="{ errors }"
                  >
                    <label class="sa-floating">First Name</label>
                    <i class="icon-traveller sa-h-sm-up"></i>
                    <input
                      type="text"
                      class="sa-form-control"
                      id="firstName"
                      name="first name"
                      v-model="signUpForm.reg.fn"
                    />
                    <span class="sa-val-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="sa-col-sm6 sa-col-md6 sa-col-lg6">
                  <ValidationProvider
                    tag="div"
                    class="sa-form-group"
                    name="last name"
                    rules="required|alpha_spaces|englishtxt"
                    v-slot="{ errors }"
                  >
                    <label class="sa-floating">Last Name</label>
                    <i class="icon-traveller sa-h-sm-up"></i>
                    <input
                      type="text"
                      class="sa-form-control"
                      id="lastName"
                      name="last name"
                      v-model="signUpForm.reg.ln"
                    />
                    <span class="sa-val-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="sa-row">
                <div class="sa-col-xs4 sa-col-sm4 sa-col-md4 sa-col-lg4">
                  <ValidationProvider
                    tag="div"
                    name="country code"
                    rules="required"
                    v-slot="{ errors }"
                    class="sa-form-group"
                  >
                    <label class="sa-floating">Code</label>
                    <i class="icon-flag sa-h-sm-up"></i>
                    <v-select
                      :options="phoneCodes"
                      id="countryCode"
                      name="country code"
                      label="nameCode"
                      :reduce="(title) => title.countryAreaCode.toString()"
                      v-model="signUpForm.otp.pc"
                    >
                      <template v-slot:option="option">
                        {{ option.countryName }} +{{ option.countryAreaCode }}
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        +{{ option.countryAreaCode }}
                      </template>
                      <span slot="no-options">No data</span>
                    </v-select>
                    <span class="sa-val-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="sa-col-xs8 sa-col-sm8 sa-col-md8 sa-col-lg8">
                  <ValidationProvider
                    name="phone number"
                    rules="required|numeric"
                    v-slot="{ errors }"
                    tag="div"
                    class="sa-form-group"
                  >
                    <label class="sa-floating">Phone Number</label>
                    <i class="icon-mobile sa-h-sm-up"></i>
                    <input
                      type="number"
                      class="sa-form-control"
                      id="phoneNumber"
                      name="phone number"
                      v-model="signUpForm.otp.ph"
                    />
                    <span class="sa-val-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <ValidationProvider
                name="email Id"
                rules="required|email|englishtxt"
                v-slot="{ errors }"
                tag="div"
                class="sa-form-group"
              >
                <label class="sa-floating">Email</label>
                <i class="icon-envelope sa-h-sm-up"></i>
                <input
                  type="text"
                  class="sa-form-control"
                  name="email Id"
                  id="emailId"
                  v-model="signUpForm.reg.email"
                />
                <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
              <ValidationProvider
                name="country"
                rules="required"
                v-slot="{ errors }"
                tag="div"
                class="sa-form-group"
              >
                <label class="sa-floating">Select Country</label>
                <i class="icon-flag sa-h-sm-up"></i>
                <v-select
                  :options="countryList"
                  id="country"
                  name="country"
                  label="title"
                  :reduce="(title) => title.value"
                  v-model="signUpForm.reg.san_off"
                  ><span slot="no-options">No data</span></v-select
                >
                <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
              <ValidationProvider
                name="gender"
                rules="required"
                v-slot="{ errors }"
                tag="div"
                class="sa-form-group"
              >
                <label class="sa-floating">Select Gender</label>
                <i class="icon-other sa-h-sm-up"></i>
                <v-select
                  :options="gender"
                  id="gender"
                  name="gender"
                  label="label"
                  :reduce="(g) => g.value"
                  v-model="signUpForm.reg.gnd"
                  ><span slot="no-options">No data</span></v-select
                >
                <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
              <ValidationProvider
                name="speciality"
                rules="required"
                v-slot="{ errors }"
                tag="div"
                class="sa-form-group"
              >
                <label class="sa-floating">Specialist In</label>
                <i class="icon-traveller sa-h-sm-up"></i>
                <v-select
                  :options="dept_list"
                  label="name"
                  id="speciality"
                  name="speciality"
                  :reduce="(dep) => dep.id"
                  true-value="top"
                  for="position"
                  false-value="bottom"
                  append-to-body
                  :calculate-position="withPopper"
                  v-model="signUpForm.reg.dept_id"
                  ><span slot="no-options">No data</span></v-select
                >
                <span class="sa-val-err">{{ errors[0] }}</span>
              </ValidationProvider>
              <input
                type="button"
                class="sa-btn sa-btn-primary sa-btn-large sa-btn-block sa-signup-btn"
                id="continue"
                name="Continue"
                value="Continue"
                @click="handleSubmit(continueToUpload)"
              />
              <!-- <div class="sa-or">
                <span class="sa-or-label">Or</span>
              </div>
              <div class="sa-social">
                <router-link to="/" class="sa-social-fb">Facebook</router-link>
                <router-link to="/" class="sa-social-google">Google</router-link>
              </div> -->
              <div class="sa-h-sm-up sa-mob-signup">
                <span>Already have an account?</span>
                <a
                  v-on:click="tabSelection = 'login'"
                  v-bind:class="[tabSelection === 'login' ? 'active' : '']"
                  >Sign in</a
                >
              </div>
            </ValidationObserver>
          </div>
        </div>
        <div
          class="sa-col-xs12 sa-col-sm6 sa-col-md7 sa-col-lg7 sa-text-right sa-h-xs"
        >
          <router-link to="/" class="d-block">
            <img src="https://img.litedev.com/images/static/logo.svg" alt="logo" height="60px"/>
          </router-link>
          <img
            src="../../assets/img/signup-doctor.svg"
            alt="Doctor"
            class="sa-img-height"
          />
        </div>
      </div>
    </div>
    <div class="sa-dialog" v-show="forgotPasDial || getOTPSmsDial">
      <div class="sa-dialog-body sa-dialog-body-mb sa-fixed-bottom" @click.stop>
        <button class="sa-btn sa-close sa-close-line" @click="closeDialog">
          <i class="icon-cancel"></i>
        </button>
        <ValidationObserver ref="forgetPwdform" v-slot="{ handleSubmit }">
          <form v-if="enterPhDial">
            <div class="sa-row">
              <div class="sa-col-xs4 sa-col-sm4 sa-col-md4 sa-col-lg4">
                <ValidationProvider
                  name="country code"
                  rules="required|numeric"
                  v-slot="{ errors }"
                  class="sa-form-group"
                >
                  <label class="sa-floating">Code</label>
                  <i class="icon-flag sa-h-sm-up"></i>
                  <v-select
                    :options="phoneCodes"
                    name="country code"
                    id="countryCode"
                    label="nameCode"
                    :reduce="(title) => title.countryAreaCode.toString()"
                    v-model="forgetPassword.phonecode"
                  >
                    <template v-slot:option="option">
                      {{ option.countryName }} +{{ option.countryAreaCode }}
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      +{{ option.countryAreaCode }}
                    </template>
                    <span slot="no-options">No data</span>
                  </v-select>

                  <span class="sa-val-err">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="sa-col-xs8 sa-col-sm8 sa-col-md8 sa-col-lg8">
                <ValidationProvider
                  name="phone number"
                  rules="required|numeric"
                  v-slot="{ errors }"
                  class="sa-form-group"
                >
                  <label class="sa-floating">Phone Number</label>
                  <input
                    type="text"
                    id="phoneNumber"
                    name="phone number"
                    class="sa-form-control"
                    v-model="forgetPassword.phonenum"
                  />
                  <span class="sa-val-err">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <button
              type="button"
              v-if="enterPhDial"
              class="sa-btn sa-btn-primary sa-btn-large sa-btn-block sa-blue-btn"
              @click="handleSubmit(getOTPSms)"
            >
              Get OTP via SMS
              <img
                src="../../assets/img/loader-white.svg"
                alt="loader"
                class="sa-sign-loader"
                v-if="loader_getOtp"
              />
            </button>
          </form>
        </ValidationObserver>
        <form v-if="getOTPSmsDial">
          <div class="sa-form-group sa-text-left sa-mob-pb20">
            <label>Enter OTP</label>
            <div class="sa-row sa-mb20 sa-otp-num">
              <div class="sa-col-xs3 sa-col-sm3 sa-col-md3 sa-col-lg3">
                <input
                  v-model="digit_1"
                  ref="digit_1"
                  name="digit1"
                  id="digit1"
                  type="text"
                  maxlength="1"
                  class="sa-form-control"
                  @input="focusInput('1')"
                />
              </div>
              <div class="sa-col-xs3 sa-col-sm3 sa-col-md3 sa-col-lg3">
                <input
                  v-model="digit_2"
                  ref="digit_2"
                  type="text"
                  maxlength="1"
                  name="digit2"
                  id="digit2"
                  class="sa-form-control"
                  @input="focusInput('2')"
                  @keyup.delete="$refs.digit_1.focus()"
                />
              </div>
              <div class="sa-col-xs3 sa-col-sm3 sa-col-md3 sa-col-lg3">
                <input
                  v-model="digit_3"
                  ref="digit_3"
                  type="text"
                  maxlength="1"
                  name="digit3"
                  id="digit3"
                  class="sa-form-control"
                  @input="focusInput('3')"
                  @keyup.delete="$refs.digit_2.focus()"
                />
              </div>
              <div class="sa-col-xs3 sa-col-sm3 sa-col-md3 sa-col-lg3">
                <input
                  v-model="digit_4"
                  ref="digit_4"
                  type="text"
                  maxlength="1"
                  name="digit4"
                  id="digit4"
                  class="sa-form-control"
                  @keyup.delete="$refs.digit_3.focus()"
                />
              </div>
            </div>
            <span class="sa-val-err" v-if="showEnterOtp">{{
              otp_err_msg
            }}</span>
            <div class="sa-text-right sa-mb20 sa-cursor">
              <a
                v-if="!resendOtp"
                @click="
                  countDownTimer();
                  getOTPSms();
                  resendOtp = true;
                "
                >Resend OTP ?</a
              >
              <a v-else>re-send again in {{ countDown }} sec</a>
            </div>
            <button
              type="button"
              class="sa-btn sa-btn-primary sa-btn-large sa-btn-block sa-blue-btn"
              @click="verifyOtp"
            >
              Confirm
            </button>
          </div>
        </form>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form v-if="otpConfirmDial" @submit.prevent>
            <ValidationProvider
              tag="div"
              name="password"
              rules="required"
              v-slot="{ errors }"
              class="sa-form-group"
            >
              <label class="sa-floating">New Password</label>
              <input
                type="password"
                name="password"
                id="password"
                class="sa-form-control"
                v-model="resetPwdForm.pw"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
              tag="div"
              name="confirmation password"
              rules="required|password:@password"
              v-slot="{ errors }"
              class="sa-form-group"
            >
              <label class="sa-floating">Confirm Password</label>
              <input
                type="password"
                name="confirmation password"
                id="confirmationpassword"
                v-model="confirmPassword"
                class="sa-form-control"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
            <button
              class="sa-btn sa-btn-primary sa-btn-large sa-btn-block sa-blue-btn"
              @click="handleSubmit(resetPassword)"
            >
              Reset Password<img
                src="../../assets/img/loader-white.svg"
                alt="loader"
                class="sa-sign-loader"
                v-if="loader_getOtp"
              />
            </button>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </main>
  <upload-licence ref="upcom" v-on:confirm-upload="signUp($event)" v-else />
</template>
<script>
import { pro_url } from "../../../config/endpoints";
import { oh_url, com_url } from "../../../config/endpoints";
import uploadLicence from "./UploadIdCard";
import { extend } from "vee-validate";
import {
  required,
  numeric,
  email,
  alpha_spaces,
  regex,
} from "vee-validate/dist/rules";
import { createPopper } from "@popperjs/core";
import Signin from "../signup/Signin";

extend("required", {
  ...required,
  message: (fieldName, placeholders) => {
    switch (fieldName) {
      case "confirmation password":
        return "Please re-enter password";
      case "country code":
        return `Country Code`;

      default:
        return `Provide ${fieldName}`;
    }
  },
});
extend("numeric", {
  ...numeric,
  message: "Please provide a valid {_field_}",
});
extend("email", {
  ...email,
  message: "Please provide a valid email Id",
});
extend("alpha_spaces", {
  ...alpha_spaces,
  message: "Please enter only alphabets",
});
extend("regex", {
  ...regex,
  message: "Spaces not allowed",
});
extend("englishtxt", {
  validate: (value) => {
    if (value === null || value === undefined || value === "") {
      return {
        valid: false,
      };
    }
    if (value) {
      return {
        valid: /^[\u0000-\u007F]+$/.test(value),
      };
    }
    return {
      valid: regex.test(value),
    };
  },
  message: "{_field_} must Enter English only",
});

extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Passwords do not match",
});
export default {
  data() {
    return {
      placement: "top",
      options: [
        { value: "S", title: "Sanar" },
        { value: "H", title: "Hospital" },
      ],
      gender: [
        { value: "M", title: "Male" },
        { value: "F", title: "Female" },
      ],
      enterPhDial: false,
      forgotPasDial: false,
      getOTPSmsDial: false,
      loader: false,
      loader_getOtp: false,
      otpConfirmDial: false,
      resendOtp: false,
      showUploadView: false,
      showEnterOtp: false,
      countDown: 45,
      confirmPassword: "",
      digit_1: "",
      digit_2: "",
      digit_3: "",
      digit_4: "",
      otp_err_msg: "Please enter otp",
      tabSelection: "login",
      countryList: [],
      dept_list: [],
      phoneCodes: [],
      gender: [
        { label: "Male", value: "M" },
        { label: "Female", value: "F" },
      ],
      forgetPassword: {},
      visibility: "password",
      loginForm: {
        pc: "",
        ph: "",
        pw: "",
        orgt: "S",
        san_off: "",
      },
      resetPwdForm: {},
      signUpForm: {
        otp: {},
        reg: {
          known_lang: "english",
          san_off: "",
          gnd: "",
          med_reg_att: {
            // "file_nm": "BB6B8D57-DC9D-44A6-91D0-E6763912CEA5.png",
            // "url": "https://img.litedev.com/profilepic/e370be5f7327cb268ff45b95bebfec61.png"
          },
        },
      },
    };
  },
  components: {
    "upload-licence": uploadLicence,
    "sign-in": Signin,
  },
  methods: {
    showSignup(){
      this.tabSelection = 'signup'
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              );
            },
          },
        ],
      });
      return () => popper.destroy();
    },
    appoint() {
      this.$router.push({ path: "/dashboard" });
    },
    closeDialog(type) {
      this.forgotPasDial = false;
      this.enterPhDial = false;
      this.getOTPSmsDial = false;
      this.otpConfirmDial = false;
      this.digit_1 = "";
      this.digit_2 = "";
      this.digit_3 = "";
      this.digit_4 = "";
      this.forgetPassword = {};
    },
    continueToUpload() {
      this.showUploadView = true;
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.resendOtp = false;
        this.countDown = 45;
      }
    },
    forgotPas() {
      this.forgotPasDial = true;
      this.enterPhDial = true;
    },
    focusInput(fd) {
      if (this["digit_" + fd] != "" && parseInt(this["digit_" + fd]) > -1) {
        this.$refs["digit_" + (1 + parseInt(fd))].focus();
      } else {
        this["digit_" + fd] = null;
      }
    },
    goBack() {
      this.showUploadView = false;
      (this.loginForm = {
        pc: "",
        ph: "",
        pw: "",
        orgt: "S",
        san_off: "",
      }),
        (this.signUpForm = {
          otp: {},
          reg: {
            known_lang: "english",
            san_off: "",
            gnd: "",
            med_reg_att: {},
          },
        });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },

    // get list of countries/office ids
    getCountryList() {
      let _self = this;
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/countryList`,
        })
        .then((response) => {
          if ((response.status = 1000)) {
            _self.countryList = response.data;
          }
        })
        .catch((e) => {
          ///console.log(e)
        });
    },

    // get list of area phone codes
    getPhoneCodes() {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/general/getStaticData`,
          body: { mtype: ["code"] },
        })
        .then((response) => {
          if ((response.status = 1000)) {
            _self.phoneCodes = response.data.code;
            if (_self.phoneCodes && _self.phoneCodes.length) {
              _self.phoneCodes.map((pc) => {
                pc.nameCode = pc.countryName + "+" + pc.countryAreaCode;
              });
            }
          }
        })
        .catch((e) => {
          // console.log(e)
        });
    },

    // get list of departments for sanar doctor resgistration
    getDeptList() {
      let _self = this;
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/getDepartments`,
        })
        .then((response) => {
          if ((response.status = 1000)) {
            _self.dept_list = response.depts;
          }
        })
        .catch((e) => {
          // console.log(e)
        });
    },

    // registration/sign up request for new sanar doctor
    signUp(e) {
      let _self = this;
      _self.loader = true;
      if (e && e.file) {
        _self.signUpForm.reg.med_reg_att = {
          file_nm: e.file.filename,
          url: e.file.url,
        };
        delete _self.signUpForm["otp"]["code"];
      } else if (e && e.otp) {
        _self.signUpForm["otp"]["code"] = e.otp;
      }
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/register`,
          body: _self.signUpForm,
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.loader = false;
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.desc,
              class: "sa-a-success",
            });
            _self.$refs.upcom.signUpSuccess(e, response);
          } else {
            _self.$refs.upcom.signUpFailure(e, response);
            // _self.$store.dispatch('SET_ALERTMESSAGE', {msg: response.message, class: 'sa-a-danger'})
          }
        })
        .catch((e) => {
          // console.log(e)
        });
    },
    // request otp for forget password
    getOTPSms() {
      let _self = this;
      _self.loader_getOtp = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${com_url}/pro/otp/pwrequestotp`,
          body: _self.forgetPassword,
        })
        .then((response) => {
          if (response.status == 1000) {
            _self.getOTPSmsDial = true;
            _self.enterPhDial = false;
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.desc,
              class: "sa-a-success",
            });
          } else {
            _self.$refs.forgetPwdform.setErrors({
              "phone number": [response.desc],
            });
            // _self.$store.dispatch('SET_ALERTMESSAGE', {msg: response.message, class: 'sa-a-danger'})
          }
          _self.loader_getOtp = false;
        })
        .catch((e) => {
          // console.log(e)
        });
    },
    // verify otp for forget password
    verifyOtp() {
      let _self = this;
      if (
        !_self.digit_1 ||
        !_self.digit_2 ||
        !_self.digit_3 ||
        !_self.digit_4
      ) {
        _self.$store.dispatch("SET_ALERTMESSAGE", {
          msg: "Please enter otp",
          class: "sa-a-danger",
        });
        return false;
      }
      // _self.showEnterOtp = false
      _self.forgetPassword["code"] =
        _self.digit_1 + _self.digit_2 + _self.digit_3 + _self.digit_4;
      _self.$store
        .dispatch("httpPost", {
          uri: `${com_url}/pro/otp/pwverifyotp`,
          body: _self.forgetPassword,
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.resetPwdForm["uid"] = response.uid;
            _self.getOTPSmsDial = false;
            _self.otpConfirmDial = true;
          } else {
            //_self.showEnterOtp = true
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.desc,
              class: "sa-a-danger",
            });
          }
        })
        .catch((e) => {
          // console.log(e)
        });
    },

    // request to reset password
    resetPassword() {
      let _self = this;
      _self.loader_getOtp = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/resetpassw`,
          body: _self.resetPwdForm,
        })
        .then((response) => {
          if (response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Password reset successfully",
              class: "sa-a-success",
            });
            // _self.$router.go('/index.html')
            _self.closeDialog();
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Error in resetting password",
              class: "sa-a-danger",
            });
          }
          _self.loader_getOtp = false;
        })
        .catch((e) => {
          // console.log(e)
        });
    },
  },
  watch: {
    tabSelection: {
      immediate: true,
      handler(val) {
        if (val == "signup") {
          this.signUpForm = {
            otp: {
              pc: "966",
            },
            reg: {
              known_lang: "english",
              san_off: "",
              gnd: "",
              med_reg_att: {},
            },
          };
        }
      },
    },
    "signUpForm.otp.pc": {
      immediate: true,
      handler(val) {
        if (val == "966") {
          this.signUpForm.reg.san_off = "SA";
        } else if (val == "91") {
          this.signUpForm.reg.san_off = "IN";
        } else if (val == "962") {
          this.signUpForm.reg.san_off = "JO";
        }
      },
    },
    "loginForm.orgt": {
      immediate: true,
      handler(val) {
        this.loginForm = { orgt: val };
      },
    },
    "signUpForm.otp.ph": function (val) {
      if (val) {
        val = String(val);
        if (val.charAt(0) == 0) {
          let _self = this;
          _self.$store.dispatch("SET_ALERTMESSAGE", {
            msg: "Phone number can not start with 0",
            class: "sa-a-danger",
          });
          this.signUpForm.otp.ph = val.substring(1);
        }
      }
    },
  },
  mounted() {
    let _self = this;
    _self.toggleBodyClass("addClass", "sa-signup");
    _self.getDeptList();
    _self.getCountryList();
    _self.getPhoneCodes();
    let coun = this.phoneCodes;
    this.signUpForm.otp.pc = coun == "SA" ? "966" : coun == "IN" ? "91" : "966";
    this.coun = this.signUpForm.otp.pc;
    let counforget = this.phoneCodes;
    this.forgetPassword.phonecode =
      counforget == "SA" ? "966" : coun == "IN" ? "91" : "966";
    this.counforget = this.forgetPassword.phonecode;
  },
  destroyed() {
    this.toggleBodyClass("removeClass", "sa-signup");
  },
};
</script>
